import React, { useEffect, createRef } from "react";
import { connect } from "react-redux";

// reactstrap components
import { Container } from "reactstrap";

const ProfilePageHeader = (props) => {
  let pageHeader = createRef();

  useEffect(() => {
    if (window.innerWidth > 991) {
      const updateScroll = () => {
        let windowScrollTop = window.pageYOffset / 3;
        pageHeader.current.style.transform =
          "translate3d(0," + windowScrollTop + "px,0)";
      };
      window.addEventListener("scroll", updateScroll);
      return function cleanup() {
        window.removeEventListener("scroll", updateScroll);
      };
    }
  });

  return (
    <>
      <div
        className="page-header clear-filter page-header-small"
        filter-color="blue"
      >
        <div
          className="page-header-image"
          style={{
            backgroundImage:
              "url(" +
              require("../../assets/img/pexels-andrea-piacquadio-3756165.jpg")
                .default +
              ")",
          }}
          ref={pageHeader}
        ></div>
        <Container>
          <div className="photo-container">
            <img
              alt="..."
              src={
                props.athlete == null
                  ? require("../../assets/img/default-avatar.png").default
                  : props.athlete.profile
              }
            ></img>
          </div>
          <h3 className="title">
            {props.user?.firstName} {props.user?.lastName}
          </h3>
          <p className="category">
            {props.athlete?.city} {props.athlete?.state}
          </p>
        </Container>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    athlete: state.strava.athlete,
    profileImage: state.strava.profileImage,
    firstName: state.strava.firstName,
    lastName: state.strava.lastName,
    city: state.strava.city,
    activities: state.strava.activities,
    error: state.authentication.error,
    authenticated: state.authentication.authenticated,
    user: state.authentication.user,
  };
};

export default connect(mapStateToProps, null)(ProfilePageHeader);
